import { ReactComponent as UnassignedIcon } from 'images/icons/unassignedIcon.svg';
import { StyledUnassignedAvatar } from './style';

export const UnassignedAvatar = ({ customStyles, className }) => (
  <StyledUnassignedAvatar id="unassigned-avatar" sx={customStyles} className={className}>
    <UnassignedIcon />
  </StyledUnassignedAvatar>
);
